export function findExtraElement<T>(arr1: T[], arr2: T[]): T | undefined {
  const combinedArray = [...arr1, ...arr2];
  const elementCounts = new Map<T, number>();

  for (const element of combinedArray) {
    elementCounts.set(element, (elementCounts.get(element) || 0) + 1);
  }

  for (const [element, count] of elementCounts.entries()) {
    if (count % 2 !== 0) {
      return element;
    }
  }

  return;
}

interface NextSliceResult<T> {
  nextSlice: T[];
  nextStartIndex: number;
}

export function getCircularSlice<T>(items: T[], sliceSize: number, startIndex: number): NextSliceResult<T> {
  if (!items || items.length === 0 || sliceSize <= 0) {
    return { nextSlice: [], nextStartIndex: startIndex };
  }

  const potentialEndIndex = startIndex + sliceSize;
  let nextSlice: T[];
  let nextStartIndex: number;

  if (potentialEndIndex > items.length) {
    // Wrap around to the beginning to complete the slice
    const remainingItems = items.slice(startIndex);
    const needed = sliceSize - remainingItems.length;
    const wrappedItems = items.slice(0, needed);
    nextSlice = [...remainingItems, ...wrappedItems];
    nextStartIndex = needed;
  } else {
    // Standard slice
    nextSlice = items.slice(startIndex, potentialEndIndex);
    nextStartIndex = potentialEndIndex === items.length ? 0 : potentialEndIndex;
  }

  return { nextSlice, nextStartIndex };
}
